var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"currentColor","strokeLinecap":"round","strokeWidth":"10.6"},[React.createElement("path",{"d":"m9.36 53h83.2","key":0}),React.createElement("path",{"d":"m57.5 92.5 39.5-39.5","key":1}),React.createElement("path",{"d":"m57.5 13.5c39.5 39.5 39.5 39.5 39.5 39.5","key":2})]));
}

Arrow.defaultProps = {"width":"400","height":"400","version":"1.1","viewBox":"0 0 106 106"};

module.exports = Arrow;

Arrow.default = Arrow;
